import useGetBrand from './useGetBrand'
export default useGetBrand
